import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Mountain } from "lucide-react";
import { api } from "@/lib/api";

export const REF_KEY = "ascend_ref";

/** /r/:code — first-touch capture. Saves the code once, logs a click, sends to register. */
export default function Referral() {
  const { code } = useParams();
  const nav = useNavigate();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const upper = (code || "").toUpperCase();
    api.get(`/affiliate/resolve/${upper}`)
      .then(() => {
        if (!localStorage.getItem(REF_KEY)) localStorage.setItem(REF_KEY, upper);
        api.post("/affiliate/click", { code: upper }).catch(() => {});
        setState("ok");
        setTimeout(() => nav("/register", { replace: true }), 900);
      })
      .catch(() => {
        setState("bad");
        setTimeout(() => nav("/", { replace: true }), 1500);
      });
  }, [code, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center relative z-10 bg-[var(--bg)] text-[var(--text)]" data-testid="referral-landing">
      <div className="text-center">
        <Mountain className="w-10 h-10 text-[var(--primary)] mx-auto mb-4" />
        <span className="tape-label">{state === "bad" ? "INVALID INVITE" : "INVITE ACCEPTED"}</span>
        <h1 className="font-display text-5xl mt-4 leading-none">
          {state === "bad" ? "UNKNOWN CODE" : "YOU'VE BEEN INVITED."}
        </h1>
        <p className="text-xs font-mono uppercase tracking-widest text-[var(--text-muted)] mt-4" data-testid="referral-status">
          {state === "checking" && "Verifying invite…"}
          {state === "ok" && `Code ${code?.toUpperCase()} locked in. Redirecting to sign-up…`}
          {state === "bad" && "That invite link doesn't exist. Taking you home…"}
        </p>
      </div>
    </div>
  );
}
